<template>
    <div class="flex flex-col gap-5 m-2">
        <p class="font-medium text-lg md:text-2xl">1 item return</p>
        <div class="flex flex-row items-center gap-x-4 border rounded-lg p-4">
            <div class="flex h-20 w-20 md:h-24 md:w-24 border rounded">
                <NuxtImg
                          :src="items.logo"
                          alt="Provider Logo"
                          title="Provider Logo"
                          class="max-h-full max-w-full"
                          @error="setDefaultImage"
                          quality="90" 
                          loading="lazy"
                      />
            </div>
            <div>
                <h5 class="font-semibold text-gray-800 line-clamp-1">{{ items.title }}</h5>
                <p class="text-sm text-gray-500 line-clamp-1">x{{ items.quantity}}</p>
                <p class="text-sm font-semibold text-gray-800 ">&#8377; {{ items.price }}</p>
            </div>
        </div>
        <div class=" border rounded-lg p-4">
            <V3StepperComponent :items="returnsteps(items.fulfillment_status, items.updated_at, items.item_id)" />
        </div>
        <div class="flex justify-end">
            <UButton size="xl" label="GOT IT" class="w-1/2" @click="emit('close')" />
        </div>
    </div>
  </template>
  
  <script setup>
  const emit = defineEmits(['close']);
  const props = defineProps(['data']);
  const items = props.data
  const refundItems = props.data.refundItems
  const dayjs = useDayjs();
  const timeFormat = 'DD MMM YYYY, hh:mmA';

  const runtimeConfig = useRuntimeConfig();
  const setDefaultImage = (event) => {
    event.imageSrc = runtimeConfig.public.defaultProductImage;
  }
  
  const returnsteps = (fulfillment_status, updated_at, item_id) => {
    const formattedDate = updated_at ? dayjs(updated_at).format(timeFormat) : '';
    let matchingRefund
    if(refundItems.length >0){
      matchingRefund = refundItems?.find(refund => refund.item_id?.includes(item_id));
    }
    if (fulfillment_status === 'Liquidated') {
      return [
        {
          title: 'Return initiated',
          subtitle: formattedDate,
          icon: 'icons/step-start.png'
        },
        ...(fulfillment_status === 'Liquidated'  ? [
          matchingRefund ? {
                title: matchingRefund.status === 'processed'?  'Refund initiated' : 'Refund failed',
                subtitle: dayjs(matchingRefund.created_at).format(timeFormat),
                icon: matchingRefund.status === 'processed'?  'icons/step.png': 'icons/step-cancel.png',
                rrn :matchingRefund.rrn
              }
            : {
                title: 'Refund failed',
                subtitle: '',
                icon: 'icons/step-cancel.png'
              }
        ] : []),
        {
          title: 'Liquidated',
          subtitle: formattedDate,
          icon: 'icons/step-end.png'
        }
      ];
    }
    return [
      {
        title: 'Return initiated',
        subtitle: formattedDate,
        icon: 'icons/step-start.png'
      },
      ...(fulfillment_status === 'Return_Failed' || fulfillment_status === 'Return_Rejected' ? [{
        title: fulfillment_status === 'Return_Failed' ? 'Return failed' : 'Return rejected',
        subtitle: formattedDate,
        icon: 'icons/step-cancel.png'
      }] : []),
      {
        title: 'Return approved',
        subtitle: fulfillment_status === 'Return_Approved' && updated_at ? formattedDate : '',
        icon: ['Return_Approved', 'Return_Picked', 'Return_Delivered','Return_Pick_Failed'].includes(fulfillment_status)
          ? 'icons/step.png'
          : 'icons/step-empty.png'
      },
      ...(fulfillment_status === 'Return_Pick_Failed' ? [{
        title: 'Return pick failed',
        subtitle: formattedDate,
        icon: 'icons/step-cancel.png'
      }] : []),
      {
        title: 'Return picked',
        subtitle: fulfillment_status === 'Return_Picked' && updated_at ? formattedDate : '',
        icon: ['Return_Picked', 'Return_Delivered'].includes(fulfillment_status)
          ? 'icons/step.png'
          : 'icons/step-empty.png'
      },
      ...(fulfillment_status === 'Return_Picked' || fulfillment_status === 'Return_Delivered'  ? [
        matchingRefund ? {
              title: matchingRefund.status === 'processed'?  'Refund initiated' : 'Refund failed',
              subtitle:dayjs(matchingRefund.created_at).format(timeFormat),
              icon: matchingRefund.status === 'processed'?  'icons/step.png': 'icons/step-cancel.png',
              rrn :matchingRefund.rrn
            }
          : {
              title: 'Refund failed',
              subtitle: '',
              icon: 'icons/step-cancel.png'
            }
      ] : []),
      {
        title: 'Return delivered',
        subtitle: fulfillment_status === 'Return_Delivered' && updated_at ? formattedDate : '',
        icon: fulfillment_status === 'Return_Delivered'
          ? 'icons/step-end.png'
          : 'icons/step-end-empty.png'
      }
    ];
  };
  
  </script>
  